export default __webpack_public_path__ + "static/realLeaf4-7d8cfd210f6bde7a3a0b7ccbf1ca0a1e.png";